// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__9Nnub","label":"ContactForm_label__Ol-7P","input":"ContactForm_input__M3UCS","btnSubmit":"ContactForm_btnSubmit__4NXlI"};